// constants.js
export const EVENTS = {
    ITEMS: {
        CHANGED: 'ev_changed_items',
        CREATE: 'ev_create_item',
        DELETE: 'ev_delete_item',
        SEARCH: 'ev_search_items',
        REFRESH: 'ev_refresh_items'
    },
    COMBOBOX: {
        RESET: 'ev_reset_combobox',
        UPDATE: 'ev_update_combobox',
        SELECTED: 'ev_selected_combobox'
    },
    CHECKBOX: {
        RESET: 'ev_reset_checkbox',
        CHECK: 'ev_check_checkbox',
        CHECK_ALL: 'ev_checkall_checkbox'
    },
    INPUT: {
        RESET: 'ev_reset_input',
        UPDATE: 'ev_update_input',
        UPDATED: 'ev_updated_input',
        DELETE: 'ev_delete_input'
    },
    AUTH: {
        LOGIN_SUCCESS: 'ev_login_success',
        LOGIN_FAILED: 'ev_login_failed',
        LOGOUT: 'ev_logout',
        LOGOUT_SUCCESS: 'ev_logout_success',
        LOGOUT_FAILED: 'ev_logout_failed'
    },
    UI: {
        CHANGE_PAGE: 'ev_change_page',
        CLICK_BUTTON_GROUP: 'ev_click_button_group',
        OPEN_MODAL_ORE: 'ev_open_modal_ore',
        OPEN_MODAL_DELETE: 'ev_open_modal_delete',
        OPEN_MODAL_ERROR: 'ev_open_modal_error',
//        OPEN_MODAL_PREMIO: 'ev_open_modal_premio',
//        OPEN_MODAL_RESULT: 'ev_open_modal_result',
//        OPEN_MODAL_RICHIESTA: 'ev_open_modal_richiesta',
//        OPEN_MODAL_WAVE: 'ev_open_modal_wave',
        TOGGLE_ACCORDION: 'ev_toggle_accordion',
        UPDATE_BREADCRUMB: 'ev_update_breadcrumb',
        UPDATE_HEADING: 'ev_update_heading',
        UPDATE_SORTING: 'ev_update_sorting',
        UPDATE_NAV: 'ev_update_nav',
        UPDATE_TH: 'ev_update_th',
        UPDATE_TD: 'ev_update_td',
        GENERIC_ERROR: 'ev_generic_error'
    },
    FILE: {
        RESET: 'ev_reset_file',
        UPDATE: 'ev_update_file',
        UPDATED: 'ev_updated_file',
        LOADED_XLS: 'loaded_xls',
        LOADED_PDF: 'loaded_pdf'
    }
};

export const KEYS = {
    COMMESSE: 'key_commesse',
    TASK: 'key_task',
    ORE: 'key_ore',
    MODAL_ORE: 'key_modal_ore'
};

export const CONFIG = {
    API_URL: 'https://nsg-api.originiagency.it/api',
    ACTIONS: 'actions',
    ASC: 'asc',
    CHECKBOX: 'cb',
    EDITABLE: 'editable',
    DATE: 'date',
    DATETIME: 'datetime',
    DESC: 'desc',
    HTML: 'html',
    NUMBER: 'number',
    N_ITEMS: 10
};

export const ACTIONS = {
    COPY: 'copy',
    EDIT: 'edit',
    DELETE: 'delete',
    SEND_EMAIL: 'send_email'
};

export const VERSION = '20250418';